import { render, staticRenderFns } from "./MtcLabHeader.vue?vue&type=template&id=7bd0790e&scoped=true&"
import script from "./MtcLabHeader.vue?vue&type=script&lang=js&"
export * from "./MtcLabHeader.vue?vue&type=script&lang=js&"
import style0 from "./MtcLabHeader.vue?vue&type=style&index=0&id=7bd0790e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd0790e",
  null
  
)

export default component.exports